import { useState } from "react";
import { Table } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import "../../../assets/styles/customTable.scss";
import useColumnResize from "../../../hooks/useColumnResize";

const AddressesNewTable = ({ data, onSortChange, onSelectionChange }) => {
  const [sortConfig, setSortConfig] = useState({ key: "AddDate", direction: "desc" });
  const { getResizeProps } = useColumnResize();
  const [selectedIds, setSelectedIds] = useState([]);
  const [selectAll, setSelectAll] = useState(false);
  const navigate = useNavigate();

  const requestSort = (key) => {
    let direction = "asc";
    if (sortConfig.key === key && sortConfig.direction === "asc") {
      direction = "desc";
    }
    const newSortConfig = { key, direction };
    setSortConfig(newSortConfig);
    onSortChange(newSortConfig);
  };

  const getSortArrow = (key) => {
    if (sortConfig.key === key) {
        return sortConfig.direction === "asc" ? "↑" : "↓";
    }
    return "";
  };

  const handleRowClick = (item) => {
    navigate(`/information/${item.id}`);
  };

  const handleSelectAll = (e) => {
    const isChecked = e.target.checked;
    setSelectAll(isChecked);

    if (isChecked) {
      const allIds = items.map(item => item.id);
      setSelectedIds(allIds);
      onSelectionChange?.(allIds);
    } else {
      setSelectedIds([]);
      onSelectionChange?.([]);
    }
  };

  const handleCheckboxChange = (e, itemId) => {
    e.stopPropagation();
    const isChecked = e.target.checked;
    let newSelectedIds;

    if (isChecked) {
      newSelectedIds = [...selectedIds, itemId];
    } else {
      newSelectedIds = selectedIds.filter(id => id !== itemId);
      setSelectAll(false);
    }

    setSelectedIds(newSelectedIds);
    onSelectionChange?.(newSelectedIds);

    if (newSelectedIds.length === items.length && items.length > 0) {
      setSelectAll(true);
    }
  };

  const items = Array.isArray(data) ? data : [];

  const formatDate = (value) => {
    if (!value) return "";
    const parsed = new Date(value);
    if (Number.isNaN(parsed.getTime())) return String(value);
    return parsed.toLocaleDateString("pl-PL");
  };

  return (
    <div>
      <Table
        responsive
        striped
        bordered
        hover
        size="sm"
        className="custom-table"
      >
        <thead>
          <tr>
            <th>
              <input 
                type="checkbox" 
                checked={selectAll}
                onChange={handleSelectAll}
              />
            </th>
            <th onClick={() => requestSort("TerminalDr")} {...getResizeProps()}>
              DR {getSortArrow("TerminalDr")}
            </th>
            <th onClick={() => requestSort("TerminalEx")} {...getResizeProps()}>
              EX {getSortArrow("TerminalEx")}
            </th>
            <th onClick={() => requestSort("GeoStatus")} {...getResizeProps()}>
              Status geokodowania {getSortArrow("GeoStatus")}
            </th>
            <th onClick={() => requestSort("Postcode")} {...getResizeProps()}>
              Kod {getSortArrow("Postcode")}
            </th>
            <th onClick={() => requestSort("Province")} {...getResizeProps()}>
              Województwo {getSortArrow("Province")}
            </th>
            <th onClick={() => requestSort("CityName")} {...getResizeProps()}>
              Miejscowość {getSortArrow("CityName")}
            </th>
            <th onClick={() => requestSort("StreetName")} {...getResizeProps()}>
              Ulica {getSortArrow("StreetName")}
            </th>
            <th onClick={() => requestSort("Number")} {...getResizeProps()}>
              Nr domu {getSortArrow("Number")}
            </th>
            <th onClick={() => requestSort("NumberInt")} {...getResizeProps()}>
              Nr domu (całk.) {getSortArrow("NumberInt")}
            </th>
            <th onClick={() => requestSort("AddDate")} {...getResizeProps()}>
              Data dodania {getSortArrow("AddDate")}
            </th>
          </tr>
        </thead>
        <tbody>
          {items.length > 0 ? (
            items.map((item, index) => (
              <tr 
                key={`${item.id}-${index}`}
                onClick={() => handleRowClick(item)}
                style={{ 
                  cursor: "pointer",
                  transition: "background-color 0.2s ease"
                }}
                onMouseEnter={(e) => e.target.closest('tr').style.backgroundColor = '#f8f9fa'}
                onMouseLeave={(e) => e.target.closest('tr').style.backgroundColor = ''}
              >
                <td onClick={(e) => e.stopPropagation()}>
                  <input 
                    type="checkbox" 
                    checked={selectedIds.includes(item.id)}
                    onChange={(e) => handleCheckboxChange(e, item.id)}
                  />
                </td>
                <td>{item.terminalDr}</td>
                <td>{item.terminalEx}</td>
                <td>{item.geoStatus}</td>
                <td>{item.postcode}</td>
                <td>{item.province}</td>
                <td>{item.cityName}</td>
                <td>{item.streetName}</td>
                <td>{item.number}</td>
                <td>{item.numberInt}</td>
                <td>{formatDate(item.addDate)}</td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan="11" className="text-center">
                Brak danych
              </td>
            </tr>
          )}
        </tbody>
      </Table>
    </div>
  );
};

export default AddressesNewTable;
